var React = require('react');

function Sort (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.7778 25.4074H23V22.8148H12.7778V20.2222H5.11111V22.8148H0V25.4074H5.11111V28H12.7778V25.4074ZM20.4444 15.2963H23V12.7037H20.4444V10.1111H12.7778V12.7037H0V15.2963H12.7778V17.8889H20.4444V15.2963ZM9.2 5.18518H23V2.59259H9.2V0H1.53333V2.59259H0V5.18518H1.53333V7.77778H9.2V5.18518Z","fill":"currentColor"}));
}

Sort.defaultProps = {"width":"23","height":"28","viewBox":"0 0 23 28","fill":"none"};

module.exports = Sort;

Sort.default = Sort;
